// Copyright (c) 2022 by Move Closer

import { ProductData } from '../../../../contexts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface ProductHeaderProps {
  product: ProductData
  shippingTimer?: ShippingTimerData
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface ShippingTimerData {
  showTimer: boolean
  limitHours: string
  firstDisabledDay?: string
  lastDisabledDay?: string
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export interface ProductHeaderIcons {
  addToCartButtonIcon: string
  heartEmptyIcon: string
  heartFullIcon: string
  notifyButtonIcon: string
  infoIcon: string
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface Slug {
  [key: string]: string
}

export enum Application {
  day = 'day',
  night = 'night',
  'day/night' = 'day/night'
}
